module.exports = __webpack_public_path__ + "src/assets/fonts/hero-pro-full-v2.ttf?908f5c40381555db3102d0e81ba53f4d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/hero-pro-full-v2.ttf
// module id = 972
// module chunks = 1